import { ICorrectResult } from "@/common/entity/CorrectResult";

export enum ActionType {
    create = 1,
    example = 2,
    edit = 3,
}

/**
 * 计算纠错次数状态
 */
export enum CalculateStatus {
    doing = 1,
    success = 2,
    fail = 3,
}

/**
 * 计算纠错次数结果或显示文本长度的信息
 */
export type CountResultTip = {
    /**
     * 提示的文本
     */
    text: string;
    /**
     * 文本的颜色
     */
    color: string;
    /**
     * 是否显示重新计算次数的按钮
     */
    showRecalculate: boolean;
};

export type CheckPageParams = {
    type?: string;
    articleId?: string;
};

export type ICorrectInfo = ICorrectResult & {
    firstIndex: number;
    secondIndex: number;
};

export type Contents = {
    html: string;
    text: string;
};

export function correctionMarkId(firstIndex: number, secondIndex: number) {
    return firstIndex + "-" + secondIndex;
}
